// extracted by mini-css-extract-plugin
export default {"slick-dots-thumb":"HomeSlider_slick-dots-thumb__EZGLV"};